import {
    httpStoreProjectSocialWelfareConditions,
    HttpStoreProjectSocialWelfareConditionsPayload
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreSocialWelfareConditions = (
    urlParams: {projectId: string},
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpStoreProjectSocialWelfareConditionsPayload>
) => {
    return useMutation({
        ...options,
        mutationFn: (payload: HttpStoreProjectSocialWelfareConditionsPayload) =>
            httpStoreProjectSocialWelfareConditions({urlParams, payload}),
        // Refetch the project so the header progressStatus (backend-computed) reflects this change.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
